'use strict';
const trackingUtils = require('../modules/utils/tracking.utils');
const postbookingPageFactory = require('components/prime_postbooking/postbookingpage_manager/js/main');
const loginFactory = require('components/user_area/login/js/main');
const createWidgetLoader = require('components-framework/widget/create_widget_loader');
const userHelper = require('od-modules/helpers/user');

Odigeo.Router.handlers.primepostbooking = function() {
    const page = 'primepostbooking';

    const widgetLoader = createWidgetLoader({
        primePostBookingManager: ['prime-postbookingpage', postbookingPageFactory],
        login: ['login-header', loginFactory],
    });
    const asyncWidgets = Odigeo.autoloadWidgetsAsync({
        getMembershipManager: ['membership-manager', 'membership_manager'],
        getUsersManager: ['users-manager', 'usersmanager'],
    });
    const openLoginForm = Odigeo._.partial(require('../modules/helpers/user.js').openLoginForm, trackingUtils, widgetLoader);

    $('#page').removeClass().addClass(page);
    $('#bread-crumbs').addClass('odf-hidden');

    Odigeo.Session.set('page', 'primepostbooking');
    Odigeo.Router.eventController = $.extend(true,
        Odigeo.Router.handlers.globalEventController,
        Odigeo.Router.eventController,
        Odigeo.Router.handlers.userEventController,
        {
            globalEvents: {
                'global:userLogged': 'onLoggedUser',
                'global:isLoggedInOk': 'onIsLoggedInOk',
            },
            viewEvents: {
                'prime-pb-register:openLoginForm': 'onOpenLoginForm',
                'prime-pb-register:isUserRegistered': 'onIsUserRegistered',
                'membership-manager:getUserTypeOk': 'onGetUserTypeResponseOk',
                'membership-manager:getUserTypeFail': 'onGetUserTypeResponseFail',
                'users-manager:logOutOk': 'onLogoutOk',
                'prime-pb-register:registerUser': 'onRegisterNewUser',
                'users-manager:registerOk': 'onRegisterEventOk',
                'users-manager:registerWithError': 'onRegisterEventError',
                'users-manager:registerError': 'onRegisterEventError',
                'recaptcha:loaded': 'onRecaptchaLoaded',
            },
            eventHandlers: {
                onOpenLoginForm: openLoginForm,
                onLoggedUser: (data) => {
                    widgetLoader.get('primePostBookingManager').execute('loginOk', data);
                },
                onIsLoggedInOk: () => {
                    userHelper.logoutUser();
                },
                onLogoutOk: () => {
                    window.location.reload();
                },
                onIsUserRegistered: (email) => {
                    asyncWidgets.getMembershipManager().execute('getUserType', email);
                },
                onGetUserTypeResponseOk: (userType) => {
                    widgetLoader.get('primePostBookingManager').execute('setUserType', userType);
                },
                onGetUserTypeResponseFail: () => {
                    widgetLoader.get('primePostBookingManager').execute('displayErrorPage');
                },
                onRecaptchaLoaded: () => {
                    widgetLoader.get('primePostBookingManager').execute('recaptchaLoaded');
                },
                onRegisterNewUser: (data) => {
                    asyncWidgets.getUsersManager().execute('submitUserRequest', {
                        action: 'register',
                        data: data,
                    });
                },
                onRegisterEventOk: (data) => {
                    widgetLoader.get('primePostBookingManager').execute('registerOk', data);
                },
                onRegisterEventError: () => {
                    widgetLoader.get('primePostBookingManager').execute('registerKO');
                },
            },
        });
    Odigeo.Router.eventController.execute();
    widgetLoader.get('primePostBookingManager');

    Odigeo.Utils.sessionTimer.reset();

    // Analytics: virtual page tracking
    widgetLoader.get('primePostBookingManager').execute('trackPage');
};
